export class RouteState {

    public get lastValidRoute(): string {
        return localStorage.getItem('lastValidRoute') || 'home';
    }

    checkRoute(routeName: string) {
        if (routeName == 'mobile-lista'
            || routeName == 'desktop-lista'
            || routeName == 'home') {
            localStorage.setItem('lastValidRoute', routeName);
        }
    }
};